<template>
    <div>
        <h3 class="mb-4">Erinnerungs-Service per E-Mail</h3>
        <p class="text-danger" v-if="error">
            <span v-if="errorMsg">{{ errorMsg }}</span>
            <span v-else>Es ist ein Fehler aufgetreten.</span>
        </p>
        <div v-if="success">
            <p class="text-success">
                Ihre Abo-Anfrage zu unserem Erinnerungs-Service wurde erfolgreich versendet.<br />
                Prüfen Sie Ihr E-Mail-Postfach. Nach erfolgreicher Bestätigung werden Sie regelmäßig über die
                Entsorgnungstermine per E-Mail erinnert.
            </p>
        </div>
        <form v-else method="post" action="" @submit.prevent="reminderSubmit">
            <div class="row">
                <div class="col-6 col-md-3">
                    <div class="form-group">
                        <label for="interval-day">Tag<sup class="text-danger">*</sup></label>
                        <select id="interval-day" name="interval" v-model="interval" class="form-control" required>
                            <option v-for="(day, interval) in interval_days" :value="interval">
                                {{ day }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-6 col-md-3">
                    <div class="form-group">
                        <label for="interval-time">Uhrzeit<sup class="text-danger">*</sup></label>
                        <select id="interval-time" name="time_hour" v-model="time" class="form-control" required>
                            <option v-for="(time, interval) in interval_times" :value="interval">
                                {{ time }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="email">E-Mail Adresse<sup class="text-danger">*</sup></label>
                        <input type="email" class="form-control" v-model="email" id="email" name="email" required />
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label>
                    <input type="checkbox" name="privacy" value="1" required />
                    Ich habe die
                    <a href="/datenschutz" target="_blank" class="text-info">Datenschutzerklärung</a>
                    gelesen und akzeptiere diese.<sup class="text-danger">*</sup>
                </label>
            </div>
            <button type="submit" class="btn btn-primary">Zum Erinnerungs-Service anmelden</button>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            error: false,
            errorMsg: "",
            success: false,
            email: "",
            interval: 1,
            time: 18,
        };
    },
    props: {
        street: {
            type: Object,
            required: true,
        },
        city: {
            type: Object,
            required: true,
        },
        district: {
            type: Object,
            required: true,
        },
        categories: {
            type: Array,
            required: true,
        },
    },
    mounted() {
        let tenantSlug = document.head.querySelector('meta[name="tenant-slug"]')?.content;

        if (tenantSlug === "rhein-pfalz-kreis") {
            this.interval = 1;
            this.time = 6;
        }
    },
    computed: {
        interval_days() {
            return {
                0: "Am gleichen Tag",
                1: "1 Tag vorher",
                2: "2 Tage vorher",
                3: "3 Tage vorher",
                4: "4 Tage vorher",
                5: "5 Tage vorher",
                6: "6 Tage vorher",
                7: "1 Woche vorher",
                14: "2 Wochen vorher",
            };
        },
        interval_times() {
            return _.fromPairs(_.range(0, 24).map((hour) => [hour, `${hour}:00`]));
        },
    },
    methods: {
        reminderSubmit(e) {
            this.success = false;
            this.error = false;
            this.errorMsg = "";

            axios
                .post(
                    "/api/email_reminder/ask_confirmation?tenant_token=" +
                        document.head.querySelector('meta[name="tenant-token"]').content,
                    {
                        street_str: this.street?.name,
                        district_str: this.district.name,
                        city_str: this.city.name,
                        street_id: this.street?.id,
                        district_id: this.district.id,
                        city_id: this.city.id,
                        tour_categories: (this.categories?.length ? this.categories : []),
                        interval: this.interval,
                        time_hour: this.time,
                        email: this.email,
                    },
                    { headers: { "Content-Type": "application/json" } }
                )
                .then((response) => {
                    this.success = true;
                })
                .catch((error) => {
                    this.error = true;

                    if (error.response.data.display_message) {
                        this.errorMsg = error.response.data.display_message;
                    }
                });
        },
    },
};
</script>
